import { PaymentSource } from "../constants";

const getPaymentRequestData = (shipmentId: string, paymentMethod: string, source: PaymentSource): any => ({
  ids: [shipmentId],
  paymentMethod,
  source,
});
export default getPaymentRequestData;
